import { render, staticRenderFns } from "./UtilInfo.vue?vue&type=template&id=bc2d119e"
import script from "./UtilInfo.vue?vue&type=script&lang=js"
export * from "./UtilInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports